<template>
  <div>
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
export default {
  components: {
    appHeader: Header,
    appFooter: Footer
  },
  data: () => ({
    message: "MainLayout.vue"
  }),
  methods: {},
  computed: {},
  mounted() {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/MainLayout.vue